import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from 'src/app/core/common';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  constructor(public route: ActivatedRoute, private router: Router) { }

  from = 0;
  private hasCurrentFrom = false;
  @Input() set currentFrom(value: number) {
    this.hasCurrentFrom = true;
    this.from = +(value || 0);
    this.load();
  }
  get handled() { return !!this.page.observers.length; }

  _limit: number;
  @Input() get limit() { return this._limit; }
  set limit(limit: number) {
    this._limit = +limit;
    this.load();
  }
  _total: number;
  @Input() get total() { return this._total; }
  set total(total: number) {
    this._total = Math.min(10000, total);
    this.load();
  }

  @Output() page = new EventEmitter<{ from: number, limit: number }>();
  ngOnInit() {
    this.route.queryParams.subscribe(page => {
      if (!this.hasCurrentFrom && page.from) { this.from = +page.from; }
      if (page.limit) { this.limit = +page.limit; }
      this.load();
    });
  }

  pages: number[] = [0];
  offset = Utility.mobile ? 3 : 6;
  lastPage: number;
  load() {
    this.pages = [];
    delete this.lastPage;
    if (!this.total || !this.limit) return;

    this.lastPage = this.total == 0 ? 0 : Math.ceil(this.total / this.limit) - 1;
    const currentPage = this.from / this.limit;
    const fromPage = Math.max(0, currentPage - this.offset - Math.max(0, this.offset - (this.lastPage - currentPage)));
    const toPage = Math.min(this.lastPage, currentPage + this.offset + Math.max(0, this.offset - currentPage));

    for (var i = fromPage; i <= toPage; i++)
      this.pages.push(i);
  }

  getPage(page: number) {
    return {
      queryParams: this.getParam(page),
      queryParamsHandling: 'merge',
      relativeTo: this.route
    };
  }

  getParam(page: number) {
    var params = { ...this.route.snapshot.queryParams };
    if (this.total) {
      if (page < 0) page = 0;
      if (page * this.limit > this.total) page = this.total / this.limit;
      params['from'] = page * this.limit;
      params['limit'] = this.limit;
    };
    return params;
  }

  setPage(page: number, silent = false) {
    if (this.handled) {
      this.from = page * this.limit;
      if (!silent)
        this.page.emit(<{ from: number, limit: number }>this.getParam(page));
    } else {
      this.router.navigate([], { queryParams: this.getParam(page), queryParamsHandling: 'merge', relativeTo: this.route });
    }
  }
}
